import { render } from "./FooterBar.vue?vue&type=template&id=7e4a1dd4&scoped=true"
const script = {}

import "./FooterBar.vue?vue&type=style&index=0&id=7e4a1dd4&scoped=true&lang=css"

import exportComponent from "/home/hans/Proyectos/Clever/AlicaMedios/alicamedios.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e4a1dd4"]])

export default __exports__